import React, { useState } from "react";
import StudentsAttendance from "components/studentsAttendance";
import HeadingComponent from "components/headingComponent";
import AttendanceType from "helper/constant/attendanceTypeKeys";
import TeachersAttendance from "components/teachersAttendance";
import "./index.css";


function Attendance() {
  const tabsData = [
    { id: 1, label: AttendanceType.attendance1 },
    { id: 2, label: AttendanceType.attendance2 },
  ];

  const [activeTab, setActiveTab] = useState(tabsData[0].id);

  // tabs are active
  const handleTabClick = async (id) => {
    if (id === 1) {
      setActiveTab(id);
    } else {
        setActiveTab(id);
    }
  };

  const Tabs = () => {
    return (
      <>
        <div className="tabs-search-div">
          <div className="tabs" style={{ flexGrow: "1" }}>
            {tabsData.map((tab) => (
              <button
                key={tab.id}
                className={`tab-button tab-buttons ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </>
    );
  };

  const header = Tabs();

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <HeadingComponent classname="mb-4" headingName="Attendance" />
          {header}
          
          {activeTab === tabsData[0].id ? <StudentsAttendance /> : <TeachersAttendance />}
        </div>
      </div>
    </div>
  );
}

export default Attendance;
